import { ConciergeBell, GraduationCap, ShieldCheck, Store, User, Volleyball, type LucideIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'shared/hooks/useAuth';
import { UserRole } from 'shared/types/user';
import { ROUTES } from 'shared/constants/routes';
import { cn } from 'shared/utils/cn';

const PERSONAS: { role: UserRole | 'visitante'; icon: LucideIcon; label: string; homePath: string }[] = [
  { role: 'visitante', icon: User, label: 'Visitante', homePath: ROUTES.HOME },
  { role: 'jogador', icon: Volleyball, label: 'Jogador', homePath: ROUTES.HOME },
  { role: 'arena', icon: Store, label: 'Dono de Arena', homePath: ROUTES.ARENA_DASHBOARD },
  { role: 'admin', icon: ShieldCheck, label: 'Admin da Plataforma', homePath: ROUTES.ADMIN_DASHBOARD },
  { role: 'instrutor', icon: GraduationCap, label: 'Instrutor', homePath: ROUTES.INSTRUCTOR_CLASSES },
  { role: 'recepcao', icon: ConciergeBell, label: 'Recepção', homePath: ROUTES.RECEPCAO_RESERVATIONS },
];

export function PresentationModeBar() {
  const { user, impersonate, logout } = useAuth();
  const navigate = useNavigate();

  async function handleSelect(persona: (typeof PERSONAS)[number]) {
    if (persona.role === 'visitante') {
      await logout();
    } else {
      impersonate(persona.role);
    }
    navigate(persona.homePath);
  }

  const activeRole = user?.role ?? 'visitante';

  return (
    <div className="flex items-center gap-2 border-b border-border bg-chip px-4 py-2 text-xs sm:justify-between">
      <span className="hidden flex-shrink-0 font-medium text-ink-secondary sm:inline">
        Modo apresentação · ver como:
      </span>
      {/* Uma linha só: no celular rola para o lado em vez de ocupar 3 linhas do topo. */}
      <div className="no-scrollbar -mx-4 flex gap-2 overflow-x-auto px-4 sm:mx-0 sm:px-0">
        {PERSONAS.map((persona) => (
          <button
            key={persona.role}
            type="button"
            onClick={() => handleSelect(persona)}
            className={cn(
              'flex flex-shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border px-3 py-1 font-medium transition-colors',
              activeRole === persona.role
                ? 'border-primary bg-primary text-surface'
                : 'border-border bg-surface text-ink-secondary hover:border-primary'
            )}
          >
            <persona.icon className="h-3.5 w-3.5" aria-hidden="true" />
            {persona.label}
          </button>
        ))}
      </div>
    </div>
  );
}
